module.exports = __webpack_public_path__ + "assets/img/study_4.a3ffff74.png";